import { useEffect, useState } from "react";
import AmrMeterGroup from "../amr-meter-group/amr-meter-group";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import StockTable from "../stock-table/stock-table";
import "./user-management.scss";
import { useDispatch, useSelector } from "react-redux";
import FullCommentary from "../new-flavors-popup/new-flavors-popup";
import { Modal } from "@mui/material";
import NewFlavorsPopup from "../new-flavors-popup/new-flavors-popup";
import PreviewTable from "../preview-table/preview-table";
import DataFiltersRow from "../data-filters-row/data-filters-row";
import {Chart} from "primereact/chart"
import ShopTable from "../shop-table/shop-table";
import UserTable from "../user-table /user-table";
import { deleteUser, getAllUsers, getUsers } from "features/authentication/userSlices";
import NewUserPopup from "../new-user-popup/new-user-popup";
import { boolean } from "yup";
import ConfirmationPopup from "../confirmation-popup/confirmation-popup";
import { getDetailedShops } from "../../shopSlices";


const UserManagement = () => {
    const dispatch: Function = useDispatch();
    const user = useSelector((state: any) => state.auth.user);
    const users = useSelector((state: any) => state.user.users);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [userToEdit, setUserToEdit] = useState(null)
    const [wordToConfirm, setWordToConfirm] = useState(null)
    const [userIdToDelete, setUserIdToDelete] = useState(null)
    const totalUsers = users.length || 0;
    useEffect(()=>{
      dispatch(getUsers(user.sub))
      dispatch(getDetailedShops())
    },[])

    const handlePopup = (isOpen: boolean) =>{
        if(!isOpen)
            dispatch(getUsers(user.sub))
        setIsPopupOpen(isOpen)
    }

  return (
    <div className="user-management">
        <PageHierarchy />

        <div className="user-management__main-counter">
            <div className="user-management__main-counter__label">
                All users
            </div>
            <div className="user-management__main-counter__value">
                {totalUsers}
            </div>
        </div>
        <div className="user-management__preview-table">
          <UserTable setIsPopupOpen={setIsPopupOpen} setUserToEdit={setUserToEdit} setWordToConfirm={setWordToConfirm} setUserIdToDelete={setUserIdToDelete}/>
        </div>
        {(isPopupOpen || userToEdit) && (
          <NewUserPopup isVisible={isPopupOpen || userToEdit} setVisible={handlePopup} userToEdit={userToEdit} setUserToEdit={setUserToEdit}/>
        )}
        {wordToConfirm && userIdToDelete && 
          <ConfirmationPopup
            wordToConfirm={wordToConfirm}
            setWordToConfirm={setWordToConfirm}
            actionText='Are you sure you want to delete this user ?'
            actionDetail='This action is not recovarable'
            fncOnConfirm={deleteUser}
            fncArgs={userIdToDelete}
            />
        }
    </div>
  );
};

export default UserManagement;
